module.exports = __webpack_public_path__ + "static/media/parkimovil-logo-h.5a2aab6a.png";